import React from 'react';
import BasicField from 'components/content/shared/fields/BasicField';
import ContainerSectionTitle from 'components/content/shared/other/ContainerSectionTitle';
import { GetInvoiceStatusColorClass } from 'functions/colors';
import { toDateString } from 'functions/formatters/date';
import { IInvoice } from 'types/backend_models/invoices/IInvoice';

interface IProps
{
	invoice: IInvoice | null
}

export function InvoiceDetailInfo(props: IProps)
{
	const labelClassName = "col-m-6";
	const valueClassName = "col-m-6";

	if (!props.invoice) {
		return null;
	} else {
		const statusColor = GetInvoiceStatusColorClass(props.invoice.statusId);
		const invoice = props.invoice;

		const today = new Date()
		const thisDate = new Date(invoice?.dueDate)
		const statusId = invoice?.statusId
		const toLate = (statusId === 'in') && (today > thisDate)

		return (
			<>
				<ContainerSectionTitle>Invoice info</ContainerSectionTitle>
				<BasicField
					label="Invoice Number"
					value={invoice.invoiceNumber}
					labelColumnClassName={labelClassName}
					valueColumnClassName={valueClassName}
				/>
				{/* <BasicField
					label="Customer"
					value={invoice.account}
					labelColumnClassName={labelClassName}
					valueColumnClassName={valueClassName}
				/> */}
				<BasicField
					label="Invoice Date"
					value={toDateString(invoice.invoiceDate, true)}
					labelColumnClassName={labelClassName}
					valueColumnClassName={valueClassName}
				/>
				<BasicField
					label="Due Date"
					value={toDateString(invoice.dueDate, true)}
					valueClassName={toLate ? ' color-alert' : ''}
					labelColumnClassName={labelClassName}
					valueColumnClassName={valueClassName}
				/>
				{/* <BasicField
					label="Paid date"
					value={toDateBE(invoice.paidOn, true)}
					labelColumnClassName={labelClassName}
					valueColumnClassName={valueClassName}
				/> */}
				<BasicField
					label="Payment Condition"
					value={invoice.paymentCondition}
					labelColumnClassName={labelClassName}
					valueColumnClassName={valueClassName}
				/>
				<BasicField
					label="Related Order"
					value={invoice.orderNumber}
					labelColumnClassName={labelClassName}
					valueColumnClassName={valueClassName}
				/>
				<BasicField
					label="Related Delivery"
					value={invoice.deliveryId}
					labelColumnClassName={labelClassName}
					valueColumnClassName={valueClassName}
				/>
				<BasicField
					label="Status"
					value={invoice.status}
					valueClassName={statusColor}
					labelColumnClassName={labelClassName}
					valueColumnClassName={valueClassName}
				/>
			</>
		);
	}
}